export const makeString = (value: boolean | number) => value.toString()

export const makeBoolean = (value: string) => value.toLowerCase() === 'true'

export const makeNumber = (value: string) => Number(value)

export const makeDate = (value: string | number) =>
  new Date(value).toLocaleDateString(navigator.language, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })

export const makeDateTime = (value: string | number) =>
  new Date(value).toLocaleDateString(navigator.language, {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  })
